import { useMemo } from 'react';

import { SettingNameType, useGetSettingQuery } from '../../../generated/graphql';
import { useGetProfile } from '../../../utils/useGetProfile';

export function useLegalPolicyAccepted() {
  const { data: settings, loading: settingsLoading } = useGetSettingQuery({
    variables: {
      name: SettingNameType.LegalAcceptanceVersion,
    },
  });

  const { data: profile, loading: profileLoading } = useGetProfile();

  const settingsLegalVersion = settings?.setting.legalAcceptanceVersion;
  const userLegalVersion = profile?.profile?.user.settings.legalVersion;
  const policiesAccepted = useMemo(() => {
    if (settingsLoading || profileLoading) return false;
    const { termsAndConditions, dataProcessingPolicy } = userLegalVersion || {};
    // check if user acceptance dates are equal the current legal version (equals means accepted)
    const terms = termsAndConditions === settingsLegalVersion?.termsAndConditions;
    const dataProcessing = dataProcessingPolicy === settingsLegalVersion?.dataProcessingPolicy;
    return terms && dataProcessing;
  }, [ settingsLoading, profileLoading, settingsLegalVersion, userLegalVersion ]);

  return policiesAccepted;
}
